<template>
  <div class="wrapper">
    <!-- <itemTalk /> -->
    <a-spin :spinning="spinning">
      <JwChat-index
        :config="config"
        :taleList="list"
        @enter="bindEnter"
        v-model="inputMsg"
        :toolConfig="tool"
        :showRightBox="false"
        scrollType="norell"
        @clickTalk="talkEvent"
        @close="close"
        ref="jwindex"
      >
        <!-- <JwChat-rightbox class="rightSlot" :config="rightConfig" @click="rightClick" /> -->
        <!-- <JwChat-talk class="rightSlot" :Talelist="talk" :config="quickConfig" @event="bindTalk" /> -->
        <!-- <b slot="tools">H</b> -->
      </JwChat-index>
    </a-spin>
  </div>
</template>

<script>
// import itemTalk from '@/components/Chat/itemTalk'
import Vue from "vue";
import { formatDate } from "@/utils/util";
export default {
  // components: { itemTalk },
  data() {
    return {
      num: 5000,
      inputMsg: "",
      list: [],
      tool: {
        // show: ['file', 'history', 'img', ['文件1', '', '美图']],
        // showEmoji: false,
        callback: this.toolEvent,
      },
      rightConfig: {
        listTip: "",
        // notice: '【公告】这是一款高度自由的聊天组件，基于AVue、Vue、Element-ui开发。点个赞再走吧 ',
        list: [],
      },
      quickConfig: {
        nav: [],
        showAdd: true,
        maxlength: 200,
        showHeader: true,
        showDeleteBtn: true,
      },
      talk: [],
      config: {
        img: "/static/images/teacher.png",
        name: "",
        dept: ``,
        callback: this.bindCover,
        // historyConfig:{
        //   tip: '加载更多',
        //   callback: this.bindLoadHistory,
        // }
      },
      fromUser: null, //当前登录用户的ID
      uploadAction: ``,
    };
  },
  props: {
    spinning: Boolean,
    currentStudent: Object,
  },
  created() {
    this.uploadAction =
      this.axios.defaults.baseURL + "/sys/common/upload";
  },
  methods: {
    getHistory() {
      const history = this.common.getStorage(this.currentStudent.id, true);
      console.log(history);
      if (history) {
        let list = history.concat(this.list);
        this.list = list;
        this.$nextTick(() => {
          console.log("chat执行");
          this.$refs.jwindex.scrollBottom();
        });
        console.log("加载历史", list, history);
      }
    },
    change() {
      this.num++;
    },
    talkEvent(play) {
      console.log(play);
    },
    bindEnter() {
      let now = formatDate(new Date().getTime(), "yyyy-MM-dd hh:mm:ss");
      console.log(now);
      this.$emit("sendMessage", this.inputMsg);
      // console.log('chat')
      // const msg = this.inputMsg
      // if (!msg) return
      // const msgObj = {
      //   date: '2020/05/20 23:19:07',
      //   text: { text: msg },
      //   mine: true,
      //   name: '我',
      //   img: '/image/three.jpeg',
      // }
      // this.list.push(msgObj)
      // setTimeout(() => {
      //   this.$refs.jwindex.scrollBottom()
      // }, 50);
      // this.sendMessage(msg)
      // formatDate(new Date().getTime(), 'yyyy-MM-dd hh:mm:ss')
    },
    addMessage(message) {
      //当该用户按下enter键或者发送之后执行的函数，将内容加到聊天窗口的同时将聊天内容存到本地的localstorage
      console.log("chat");
      const msg = message;
      if (!msg) return;
      const msgObj = {
        date: new Date().getTime(),
        text: { text: msg },
        mine: true,
        name: "我",
        img: "/static/images/student.png",
      };
      this.list.push(msgObj);
      let chatData = this.common.getStorage(this.currentStudent.id, true);
      console.log(chatData);
      if (!chatData) {
        this.common.setStorage(this.currentStudent.id, [msgObj]);
      } else if (chatData.length < 100) {
        chatData.push(msgObj);
        this.common.setStorage(this.currentStudent.id, chatData);
      } else {
        chatData.push(msgObj);
        this.common.setStorage(
          this.currentStudent.id,
          chatData.splice(chatData.length - 100, chatData.length - 1)
        );
      }
      setTimeout(() => {
        this.$refs.jwindex.scrollBottom();
      }, 50);
    },
    newMessage(msg) {
      // 收到新消息，将其内容加到聊天窗口
      this.list.push(msg);
      setTimeout(() => {
        this.$refs.jwindex.scrollBottom();
      }, 50);
    },
    toolEvent(type, plyload) {
      console.log("tools", type, plyload);
      const formData = new FormData();
      formData.append("biz", `chat`);
      formData.append("file", plyload[0]);
      this.axios.post(this.uploadAction, formData).then((res) => {
        console.log(res);
        if (res.success) {
          this.$message.success(res.message);
          // this.addMessage(`<span>我向您发送了一个附件，地址是：<a style="color: #f5d57a;" href="${res.message}">${res.message}<a/><span/>`)
          this.$emit(
            "sendMessage",
            `<span>我向您发送了一个附件，地址是：<a href="${res.message}">${res.message}<a/><span/>`
          );
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    bindCover(type) {
      console.log("header", type);
    },
    rightClick(type) {
      console.log("rigth", type);
    },
    bindTalk(play) {
      console.log("talk", play);
    },
    close() {
      console.log("关闭");
      this.$emit("close");
    },
    test() {
      var test = 0;
      test = formatDate(1605695155, test);
      console.log(test);
    },
  },
  mounted() {
    // this.list = []
    // this.getHistory()
  },
  watch: {
    currentStudent: {
      handler(val, oldVal) {
        console.log(val);
        this.list = [];
        this.config.name = val.teacherName;
        this.config.dept = val.status ? val.status : "离线";
        //        img: '/image/one.jpeg',
        // name: '学生张三',
        // dept: `郑州大学`,
        this.getHistory();
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.rightSlot {
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
}
</style>
<style>
.active {
  color: red;
}
.wrapper {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/chat/chat.vue